module.exports = __webpack_public_path__ + "static/about_system_raport-3f8375d3e11a06ef68b3bae286588632.png";